import React from 'react';
import PropTypes from 'prop-types';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

class PreviewTableHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.renderTableHeaderColumns = this.renderTableHeaderColumns.bind(this);
    this.toCamelCase = this.toCamelCase.bind(this);
  }

  createSortHandler(event, property) {
    this.props.onRequestSort(event, property);
  }

  toCamelCase(input) {
    // If a string is wrapped in '|' symboles it should be ignored
    if (/\|.*?\|/g.test(input)) {
      return input.replace(/^\||\|$/g, '');
    }

    // when a string is completely uppercase don't convert to camelCase
    if (input === input.toUpperCase()) {
      return input;
    }

    const codeIdArray = input.split(' ');
    let codeId = codeIdArray.map((value, index) => {
      if (index === 0) return value;
      return value.charAt(0).toUpperCase() + value.slice(1);
    }).join('');

    // eslint-disable-next-line max-len
    // Only set the first letter to lowercase if the second one is lowercase (this is to make 'BTW nummer' format as 'BTWNumber')
    if (codeId.charAt(1) === codeId.charAt(1).toLowerCase()) {
      codeId = codeId.charAt(0).toLowerCase() + codeId.slice(1);
    }

    return codeId;
  }

  renderTableHeaderColumns() {
    const {
      row,
      orderBy,
      order,
    } = this.props;

    return row.map(column => (
      <TableCell
        key={column.key}
        sortDirection={orderBy === column.key ? order : false}
        style={{ padding: '10px', paddingRight: '0px' }}
      >
        <Tooltip
          title="Sort"
          placement={column ? 'bottom-end' : 'bottom-start'}
          enterDelay={300}
        >
          <TableSortLabel
            active={orderBy === column.key}
            direction={order}
            onClick={e => this.createSortHandler(e, column.key)}
          >
            {this.toCamelCase(column.name)}
          </TableSortLabel>
        </Tooltip>
      </TableCell>
    ), this);
  }

  render() {
    return (
      <TableHead>
        <TableRow>
          {this.renderTableHeaderColumns()}
        </TableRow>
      </TableHead>
    );
  }
}

PreviewTableHeaderComponent.propTypes = {
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  row: PropTypes.arrayOf(PropTypes.shape([{
    key: PropTypes.string,
    name: PropTypes.string,
  }])).isRequired,
};

export default PreviewTableHeaderComponent;
